var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8BaseLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9693 31.8794C24.7058 31.8794 31.7881 24.7971 31.7881 16.0606C31.7881 7.32405 24.7058 0.241699 15.9693 0.241699C7.23274 0.241699 0.150391 7.32405 0.150391 16.0606C0.150391 24.7971 7.23274 31.8794 15.9693 31.8794Z",
    fill: "#EA4235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9695 26.9888C12.2261 26.9888 8.93555 23.97 8.93555 20.1662C8.93555 17.8417 10.0223 15.97 12.0752 14.8832C10.8978 13.736 10.2035 12.5888 10.2035 10.8983C10.2035 7.6379 12.7091 5.10205 15.9695 5.10205C19.2299 5.10205 21.7658 7.6379 21.7658 10.8983C21.7658 12.5888 21.0412 13.736 19.8639 14.8832C21.9167 15.97 23.0035 17.8417 23.0035 20.1662C22.9733 23.97 19.7129 26.9888 15.9695 26.9888ZM15.9695 16.936C14.1884 16.936 12.7393 18.3851 12.7393 20.1662C12.7393 21.9473 14.1884 23.3964 15.9695 23.3964C17.7507 23.3964 19.1997 21.9473 19.1997 20.1662C19.1997 18.3851 17.7507 16.936 15.9695 16.936ZM15.9695 8.6945C14.7318 8.6945 13.7657 9.7511 13.7657 10.9587C13.7657 12.1662 14.762 13.1926 15.9695 13.1926C17.1771 13.1926 18.2035 12.1662 18.2035 10.9587C18.2035 9.72092 17.2073 8.6945 15.9695 8.6945Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8BaseLogoSmall);
export default __webpack_public_path__ + "static/media/8baseLogoSmall.09379984.svg";
export { ForwardRef as ReactComponent };